import React, { useEffect, useRef, useState } from "react";
import { fetchKindsIntro } from "@Services/kindsum";
import { IKindsPcInfo } from "@Types/kindsum";
import { useQuery } from "react-query";
import { setUrlFormat } from "@Lib/common";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";

interface IKindSumIntro {
  data: IKindsPcInfo;
}

const KindSumIntro: React.FC<IKindSumIntro> = ({ data }) => {
  const { kindId, brandName, kindName } = data;
  const [introText, setIntroText] = useState("");

  const initData = {};
  const { data: introData = initData, refetch } = useQuery<any>(
    [`fetchKindsIntro`, kindId],
    async () => {
      const res: { status, data } = await fetchKindsIntro({ kindId });

      if (res?.status === 12000) {
        setIntroText(res.data.introduction?.feature);
        return res.data;
      }
      return initData;
    },
    {
      enabled: !!kindId,
    },
  );

  useEffect(() => {
    if (!!kindId) {
      refetch();
    }
  }, [kindId]);

  if (!introData || !introData.navs?.length) {
    return null;
  }

  const { introduction, navs } = introData;


  return (
    <div id={"KindSumIntro"} className='text-black w-full mt-40'>
      <div
        className="w-full border-1 border-[#F9F9F9] border-solid rounded-4 pr-20 pb-16 pt-6 relative" style={{ background: 'linear-gradient(0deg,#ebf3ff, #ffffff 50%)' }}
      >
        <div className="flex items-center mb-16 pl-120" id="tracking-IntroNavs">
          <p className="text-20 font-[600] bg-[url('https://photo.8891.com.tw/2025/02/26/1740535542268455.png')] bg-no-repeat bg-left-center bg-contain w-120 h-38 pl-12 flex items-center justify-start absolute left-0 -top-4">車款介紹</p>
          {Array.isArray(navs) && navs.map((item, index) => {
            const isLast = index === navs.length - 1;
            const isActive = index === 0;

            return (
              <a
                target="_blank"
                href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/introduction.html?type=${item.key}`}
                key={index}
                className="flex items-center gap-10 mr-10"
              >
                <p className={`text-16 hover:text-[#3264FF] cursor-pointer ${isActive ? 'text-[#3264FF]' : 'text-[#666666]'}`}>{item.title}</p>
                {!isLast && <i className="w-1 h-14 bg-[#E8E8E8]" />}
              </a>
            )
          })}
        </div>

        <a target="_blank" href={`/kind-intro/${kindId}`}>
          {!!introduction.feature &&
            <div className="w-full h-[50px] mr-0 ml-auto pl-20 flex items-center justify-start relative">
              <img src="https://photo.8891.com.tw/2025/02/26/1740535542287311.png" alt="" className="w-46 h-46 object-contain mr-14" />


              <div className='flex-1 text-16 text-[#1d2029] relative'>
                <HTMLEllipsis
                  className={`text-16 text-[#1d2029] max-h-56 leading-28 relative w-[786px]`}
                  unsafeHTML={introText}
                  maxLine='2'
                  ellipsis='...'
                  basedOn='letters'
                  onReflow={({ html, clamped }) => {
                    if (clamped) {
                      setIntroText(html.replace(/(.{3})(<span class="LinesEllipsis-unit">)/g, "$2"));
                    }
                  }}
                />

                <a
                  id="tracking-IntroNavs-More"
                  className='text-16 cursor-pointer text-[#666] hover:text-[#666] absolute -right-[28px] -bottom-[10px] flex items-center gap-4 w-[108px] h-[50px] justify-center'
                  target="_blank"
                  href={`/kind-intro/${kindId}`}
                  style={{
                    backgroundImage: 'url(https://photo.8891.com.tw/2025/02/28/1740710394338945.png)',
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                  }}
                >
                  更多
                  <img src="https://photo.8891.com.tw/2025/02/26/1740549690353185.png" alt="" className="w-8 h-14" />
                </a>
              </div>
            </div>
          }
        </a>


      </div>
    </div>
  );
};

export default KindSumIntro;
